var _excluded = ["children", "maxFiles", "maxSize", "accept", "disabled", "onUpload"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import CheckIcon from '@material-ui/icons/Check';
import WarningIcon from '@material-ui/icons/Warning';
import Button from '../Button';
import CircularProgress from '../CircularProgress';
var PendingIndicator = function PendingIndicator(_ref) {
  var accepted = _ref.accepted,
    rejected = _ref.rejected;
  if (accepted) {
    return /*#__PURE__*/React.createElement(CheckIcon, {
      color: "inherit",
      size: 16
    });
  }
  if (rejected) {
    return /*#__PURE__*/React.createElement(WarningIcon, {
      color: "inherit",
      size: 16
    });
  }
  return /*#__PURE__*/React.createElement(CircularProgress, {
    color: "inherit",
    size: 16
  });
};
PendingIndicator.propTypes = process.env.NODE_ENV !== "production" ? {
  accepted: PropTypes.bool,
  rejected: PropTypes.bool
} : {};
PendingIndicator.defaultProps = {
  accepted: false,
  rejected: false
};
function FileUploadButton(_ref2) {
  var children = _ref2.children,
    maxFiles = _ref2.maxFiles,
    maxSize = _ref2.maxSize,
    accept = _ref2.accept,
    disabled = _ref2.disabled,
    onUpload = _ref2.onUpload,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded);
  var _useState = useState(false),
    pending = _useState[0],
    setPending = _useState[1];
  var _useState2 = useState(false),
    accepted = _useState2[0],
    setAccepted = _useState2[1];
  var _useState3 = useState(false),
    rejected = _useState3[0],
    setRejected = _useState3[1];
  var handleFileSave = useCallback(function (results) {
    var promises = [];
    var files = [].concat(results);
    files.forEach(function (file, i) {
      return promises.push(new Promise(function (resolve) {
        var reader = new FileReader();
        reader.onload = function () {
          files[i].url = reader.result;
          resolve();
        };
        reader.readAsDataURL(file);
      }));
    });
    Promise.all(promises).then(function () {
      setAccepted(true);
      setTimeout(function () {
        setPending(false);
        setAccepted(false);
      }, 400);
      onUpload(files);
    });
  }, [onUpload]);
  var onDrop = function onDrop(results) {
    setTimeout(function () {
      return handleFileSave(results);
    }, 400);
  };
  var onDropAccepted = function onDropAccepted() {
    setPending(true);
    setTimeout(function () {
      return setAccepted(true);
    }, 400);
  };
  var onDropRejected = function onDropRejected() {
    setPending(true);
    setTimeout(function () {
      return setRejected(true);
    }, 400);
    setTimeout(function () {
      return setRejected(false);
    }, 800);
  };
  var _useDropzone = useDropzone({
      onDrop: onDrop,
      onDropAccepted: onDropAccepted,
      onDropRejected: onDropRejected,
      disabled: disabled,
      noDrag: true,
      maxFiles: maxFiles,
      maxSize: maxSize,
      accept: accept,
      multiple: maxFiles > 1
    }),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps;
  return /*#__PURE__*/React.createElement("span", getRootProps(), /*#__PURE__*/React.createElement(Button, _extends({
    loading: true,
    disabled: disabled,
    pending: pending,
    pendingIndicator: /*#__PURE__*/React.createElement(PendingIndicator, {
      accepted: accepted,
      rejected: rejected
    })
  }, rest), /*#__PURE__*/React.createElement("input", getInputProps()), children));
}
FileUploadButton.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Component, node or text
   */
  children: PropTypes.node.isRequired,
  /**
   * 	Maximum accepted number of files.
   */
  maxFiles: PropTypes.number,
  /**
   * 	Maximum file size (in bytes)
   */
  maxSize: PropTypes.number,
  /**
   * Array of acceptable file types...
   */
  accept: PropTypes.arrayOf(PropTypes.string),
  /**
   * If `true`, the button should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,
  /**
   * Do something with the file upload result
   */
  onUpload: PropTypes.func.isRequired
} : {};
FileUploadButton.defaultProps = {
  maxFiles: 1,
  maxSize: 1887436,
  accept: ['image/*', 'application/pdf'],
  disabled: false
};
export default FileUploadButton;